import React from 'react';
import styled from 'styled-components';
import { FiFilter, FiSearch, FiX } from 'react-icons/fi';
import theme from '../../styles/theme';

const Container = styled.div`
  background: ${theme.colors.background.secondary};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.xl};
  padding: ${theme.spacing[6]};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing[6]};
`;

const Title = styled.h3`
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.lg};
  font-weight: 600;
`;

const Actions = styled.div`
  display: flex;
  gap: ${theme.spacing[2]};
`;

const ActionButton = styled.button`
  padding: ${theme.spacing[2]} ${theme.spacing[4]};
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid ${theme.colors.border.primary};
  background: transparent;
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.colors.background.primary};
    color: ${theme.colors.primary[500]};
    border-color: ${theme.colors.primary[500]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: ${theme.spacing[4]};
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

const Label = styled.label`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  font-weight: 500;
`;

const Input = styled.input`
  padding: ${theme.spacing[3]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.sm};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }

  &::placeholder {
    color: ${theme.colors.text.muted};
  }
`;

const Select = styled.select`
  padding: ${theme.spacing[3]};
  border: 1px solid ${theme.colors.border.primary};
  border-radius: ${theme.borderRadius.lg};
  background: ${theme.colors.background.primary};
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes.sm};
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary[500]};
    box-shadow: 0 0 0 3px ${theme.colors.primary[500]}20;
  }
`;

const ClienteSobreFiltros = ({
  filtros,
  onFiltrosChange,
  onBuscar,
  loading,
  clientes = [],
}) => {
  const handleChange = (field, value) => {
    onFiltrosChange({
      ...filtros,
      [field]: value,
    });
  };

  const limpar = () => {
    const filtrosLimpos = {
      search: '',
      clienteId: '',
    };
    onFiltrosChange(filtrosLimpos);
    // Executar busca automaticamente após limpar filtros, passando os filtros limpos diretamente
    if (onBuscar) {
      onBuscar(filtrosLimpos);
    }
  };

  const temFiltros = Boolean(filtros.search) || Boolean(filtros.clienteId);

  return (
    <Container>
      <Header>
        <Title>
          <FiFilter />
          Filtros
        </Title>
        <Actions>
          <ActionButton onClick={limpar} disabled={!temFiltros}>
            <FiX />
            Limpar
          </ActionButton>
          <ActionButton onClick={onBuscar} disabled={loading}>
            <FiSearch />
            {loading ? 'Buscando...' : 'Buscar'}
          </ActionButton>
        </Actions>
      </Header>

      <Grid>
        <Field>
          <Label>Busca Geral</Label>
          <Input
            type="text"
            placeholder="Descrição, cidade, estado..."
            value={filtros.search}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </Field>

        <Field>
          <Label>Cliente</Label>
          <Select
            value={filtros.clienteId}
            onChange={(e) => handleChange('clienteId', e.target.value)}
          >
            <option value="">Todos os clientes</option>
            {clientes.map((cliente) => (
              <option key={cliente.id} value={cliente.id}>
                {cliente.nome_fantasia || cliente.nome_social || `Cliente #${cliente.id}`}
              </option>
            ))}
          </Select>
        </Field>
      </Grid>
    </Container>
  );
};

export default ClienteSobreFiltros;


